import { Component, ContentChild, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';

@Component({
  selector: 'epp-color-picker',
  templateUrl: './epp-color-picker.component.html',
  styleUrls: [`./epp-color-picker.component.scss`],
})
export class EppColorPickerComponent implements OnInit {

  @Input() list: string[]
  @Input() color: string = ''
  @Output() colorChange = new EventEmitter<string>();
  @ContentChild('colorBlock') colorBlock: TemplateRef<ElementRef>;

  constructor () {
  }
  ngOnInit () {

  }

  colorSelect (color: string) {
    this.color = color
    this.colorChange.emit(color)
  }

}
